import React, { Fragment } from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { PercentInput, DatePicker } from "components/Global/FormikMaterial";

const StyledDatePicker = styled(DatePicker)`
  & {width:100%;
    margin-top:-2px !important;
  }
`;
const StyledPercentInput = styled(PercentInput)`
  & {width:100%;}
`;
const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
 }`;
const FlatPercentageFields = () => (
  <>
    <Grid item xs={6}>
      <StyledDatePicker
        label={<StyledLabel>{"Prepayment Date"}</StyledLabel>}
        fieldName="prepaymentDate"
      />
    </Grid>
    <Grid item xs={6}>
      <StyledPercentInput
        label={<StyledLabel>{"Flat %"}</StyledLabel>}
        decimalScale={3}
        fieldName="flatPercentage"
        allowNegative={false}
      />
    </Grid>
  </>
);
export default FlatPercentageFields;
